
export class RadFlowBaseModel {
    
    id: number;
    flow: string;

    constructor(
        id: number,
        flow: string
    ) {
        this.id = id;
        this.flow = flow;
    }

    public static fromJson(json: any): RadFlowBaseModel {
        return new RadFlowBaseModel(
            json["id"],
            json["flow"]
        );
    }
}